import {
  getContractsSuccess,
  countContractsSuccess,
} from "features/contractSlice";
import { call, put, takeLatest } from "redux-saga/effects";
import { DELETE, GET, PATCH, POST, PUT } from "services/ServiceBase";
import ServiceURL from "services/ServiceURL";
import { ActionType } from "type";
import _ from "lodash";

export function* getContracts(data: ActionType): any {
  const { callback, body, query, skipUpdateReducer } = data.payload;
  const url = `${ServiceURL.contract}?${query ?? ""}`;
  try {
    const res = yield call(GET, url, body);
    if (!!res?.code && !!res?.message) {
      callback.failed(res?.message);
    } else {
      if (!skipUpdateReducer)
        yield put(getContractsSuccess(_.get(res, "data", {})));
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export function* getContractByStatus(data: any): any {
  const { callback, body, query, skipUpdateReducer } = data.payload;
  const url = `${ServiceURL.getContractsByStatus}?${query ?? ""}`;
  try {
    const res = yield call(GET, url, body);
    if (!!res?.code && !!res?.message) {
      callback.failed(res?.message);
    } else {
      if (!skipUpdateReducer)
        yield put(getContractsSuccess(_.get(res, "data", {})));
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export function* caculateContracts(data: ActionType): any {
  const { callback, body, query, skipUpdateReducer } = data.payload;
  const url = `${ServiceURL.contract}/caculate?${query ?? ""}`;
  try {
    const res = yield call(POST, url, body);
    if (!!res?.code && !!res?.message) {
      callback.failed(res?.message);
    } else {
      if (!skipUpdateReducer)
        yield put(countContractsSuccess(_.get(res, "data", {})));
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export function* createContracts(data: ActionType): any {
  const { callback, body } = data.payload;
  const url = ServiceURL.contract;
  try {
    const res = yield call(POST, url, body);
    if (!!res?.response?.data?.code && !!res?.response?.data?.message) {
      callback.failed(res?.response?.data?.message);
    } else {
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export function* countContracts(data: ActionType): any {
  const { callback, body } = data.payload;
  const url = ServiceURL.getNumberOfStatusContract;
  try {
    const res = yield call(GET, url, body);
    if (!!res?.response?.data?.code && !!res?.response?.data?.message) {
      callback.failed(res?.response?.data?.message);
    } else {
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export function* updateContracts(data: ActionType): any {
  const { callback, body, params } = data.payload;
  const url = `${ServiceURL.contract}/${params}`;
  try {
    const res = yield call(PATCH, url, body);
    if (!!res?.response?.data?.code && !!res?.response?.data?.message) {
      callback.failed(res?.response?.data?.message);
    } else {
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}
export function* deleteContracts(data: ActionType): any {
  const { callback, body, params } = data.payload;
  const url = `${ServiceURL.contract}/${params}`;
  try {
    const res = yield call(DELETE, url, body);
    if (res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      callback.success(res);
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export function* closePackService(data: ActionType): any {
  const { params, query, callback } = data.payload;
  const url = `${ServiceURL.contract}/closePackService/${params}?${query}`;
  try {
    const res = yield call(PATCH, url, null);
    if (res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      callback.success(res);
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export function* addPackService(data: ActionType): any {
  const { callback, body, params } = data.payload;
  const url = `${ServiceURL.contract}/addPackService/${params}`;
  try {
    const res = yield call(PATCH, url, body);
    if (res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      callback.success(res);
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export function* updateSupport(data: ActionType): any {
  const { callback, body, params } = data.payload;
  const url = `${ServiceURL.contract}/updateSupport/${params}`;
  try {
    const res = yield call(PATCH, url, body);
    if (res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      callback.success(res);
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export default function* contractSaga() {
  yield takeLatest("contractSlice/getContracts", getContracts);
  yield takeLatest("contractSlice/createContracts", createContracts);
  yield takeLatest("contractSlice/updateContracts", updateContracts);
  yield takeLatest("contractSlice/deleteContracts", deleteContracts);
  yield takeLatest("contractSlice/caculateContracts", caculateContracts);
  yield takeLatest("contractSlice/countContracts", countContracts);
  yield takeLatest("contractSlice/getContractByStatus", getContractByStatus);
  yield takeLatest("contractSlice/closePackService", closePackService);
  yield takeLatest("contractSlice/addPackService", addPackService);
  yield takeLatest("contractSlice/updateSupport", updateSupport);
}
